import React from 'react';
import {Box, Typography} from '@mui/material';
import {Controller, Control, FieldErrors} from 'react-hook-form';
import ArrSingleSelectDropdown from '../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {FormValues} from '../schema';
import {t} from 'i18next';

const DateTimeSection: React.FC<{
  control: Control<FormValues>;
  errors: FieldErrors<FormValues>;
  timeZone: {key: string; displayValue: string}[];
  dateFormat: {key: string; displayValue: string}[];
  disabled?: boolean;
}> = ({control, errors, timeZone, dateFormat, disabled = false}) => {
  return (
    <Box className="section-block">
      <Typography
        className="section-title typo-text subhead4_size"
        tabIndex={0}
        data-testid={`date-time-section-title`}>
        {t('ingestions.Wizard.dateAndTime.title')}
      </Typography>
      <Box className="row two-cols">
        <Box>
          <Controller
            name="dateFormat"
            control={control}
            render={({field}) => (
              <ArrSingleSelectDropdown
                searchable
                dropdownLabel={t('ingestions.Wizard.dateAndTime.dropdownLabel')}
                dropdownItems={dateFormat}
                selectedValues={field.value ?? null}
                onSelectionChange={(val) => field.onChange(val)}
                error={!!errors?.dateFormat}
                errorText={(errors?.dateFormat?.message as string) ?? undefined}
                dropdownItemDisplay="displayValue"
                dropdownItemKey="key"
                disabled={disabled}
                dataTestId="asd-date-format-dropdown"
                selectRestProps={{
                  'aria-label': t(
                    'ingestions.Wizard.ariaLabels.dateTimeSection.dateFormatDropdown'
                  ),
                  'aria-required': true,
                  'aria-invalid': !!errors?.dateFormat,
                  'aria-describedby': errors?.dateFormat
                    ? 'date-format-error'
                    : undefined,
                }}
                inputLabelProps={{
                  'aria-label': 'Select a format from the available options',
                }}
                tabIndex={-1}
              />
            )}
          />
        </Box>
        <Box tabIndex={disabled ? -1 : 0} aria-label="inactive time zone">
          <Controller
            name="timeZone"
            control={control}
            render={({field}) => (
              <ArrSingleSelectDropdown
                searchable
                dropdownLabel={t('ingestions.Wizard.dateAndTime.dropdownTime')}
                dropdownItemDisplay="displayValue"
                dropdownItemKey="key"
                dropdownItems={timeZone}
                selectedValues={field.value ?? null}
                onSelectionChange={(val) => field.onChange(val)}
                error={!!errors?.timeZone}
                errorText={(errors?.timeZone?.message as string) ?? undefined}
                disabled /* original component had disabled - keep always disabled */
                dataTestId="asd-time-zone-dropdown"
                selectRestProps={{
                  'aria-label': t(
                    'ingestions.Wizard.ariaLabels.dateTimeSection.timeZoneDropdown'
                  ),
                  'aria-required': false,
                  'aria-invalid': !!errors?.timeZone,
                  'aria-describedby': errors?.timeZone
                    ? 'time-zone-error'
                    : undefined,
                }}
                tabIndex={-1}
              />
            )}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DateTimeSection;
